/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type HistoryDtoHistoryType = (typeof HistoryDtoHistoryType)[keyof typeof HistoryDtoHistoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HistoryDtoHistoryType = {
  JOURNAL_ENTRY: 'JOURNAL_ENTRY',
  PATIENT_CREATED: 'PATIENT_CREATED',
  THERAPY_FINISHED: 'THERAPY_FINISHED',
  LAB_REPORT_CREATED: 'LAB_REPORT_CREATED',
  THERAPY_MEDICATION_CHANGE: 'THERAPY_MEDICATION_CHANGE',
  RESIDENCY_CHANGED: 'RESIDENCY_CHANGED',
  DOT_STARTED: 'DOT_STARTED',
  ISOLATION_STARTED: 'ISOLATION_STARTED',
  ISOLATION_ENDED: 'ISOLATION_ENDED',
  HOSPITALIZATION_STARTED: 'HOSPITALIZATION_STARTED',
  HOSPITALIZATION_ENDED: 'HOSPITALIZATION_ENDED',
} as const;
